import React from 'react';

interface InfoGridProps {
  children: React.ReactNode;
  cols?: number;
  className?: string;
}

export const InfoGrid: React.FC<InfoGridProps> = ({
  children,
  cols = 2,
  className = '',
}) => {
  const gridCols = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
  }[cols] || 'grid-cols-1 md:grid-cols-2';

  return (
    <div className={`grid ${gridCols} gap-6 ${className}`}>
      {children}
    </div>
  );
};

interface InfoItemProps {
  label: string;
  value: React.ReactNode;
  className?: string;
}

export const InfoItem: React.FC<InfoItemProps> = ({ label, value, className = '' }) => (
  <div className={`flex flex-col gap-1 ${className}`}>
    <span className="text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
      {label}
    </span>
    <div className="text-sm font-semibold text-slate-900 dark:text-white">
      {value || '—'}
    </div>
  </div>
);
